import http from '@/utils/request';
import global_ from '@/utils/Global'
let apiUrl_ZS = global_.BASE_URL_ZS;

export const getnavDataList = params => {
  return http.requestPost(apiUrl_ZS + 'index.php/system_menu/get_page_menu_list', params)
}
/*获取数据列表*/
export const getDataList = params => {
  return http.requestPost(apiUrl_ZS + 'layout_index_content/get_index_info', params)
}
/*获取控制显示隐藏列表*/
export const layout_page_management = params => {
  return http.requestPost(apiUrl_ZS + 'layout_page_management/get_management_list', params)
}
/*获取控制显示隐藏列表*/
export const add_access = params => {
  return http.requestPost(apiUrl_ZS + 'layout_index_content/add_access', params)
}
/*获取筛选数据列表*/
// export const getchushihuaDataList = params => {
//   return http.requestPost(apiUrl + 'Web_serve/get_dynamic_category_mh', params)
// }

/*添加*/
// export const addData = params => {
//   return http.requestPost(apiUrl + '/Business/add', params)
// }

/*删除*/
// export const deleteData = params => {
//   return http.requestPost(apiUrl + '/Business/real_delete', params)
// }

/*根据id获取信息*/
// export const getById = params => {
//   return http.requestPost(apiUrl + '/Business/get_by_id', params)
// }

// /*修改保存*/
// export const editData = params => {
//   return http.requestPost(apiUrl + '/Business/update', params)
// }



// WEBPACK FOOTER //
// ./src/components/page/home/api/homeTemplateOne.js